<script lang="ts" setup>
import type { CareerBox } from '~/components/career/box/CareerBox.vue'
export interface CareerBoxListProps {
    data: CareerBox[]
}

const props = defineProps<CareerBoxListProps>()
</script>

<template>
  <ul>
    <li
      v-for="(jobOffer, index) in props.data"
      :key="`cpb-${index}`"
      :class="{ 'mb-2': index < props.data.length - 1 }"
    >
      <Tracker :data="{ title: jobOffer.position }">
        <CareerBox
          heading-level="h4"
          :data="jobOffer"
        />
      </Tracker>
    </li>
  </ul>
  <IconsWrapper>
    <IconsSymbolFile />
    <IconsSymbolLocation />
  </IconsWrapper>
</template>
